import { useSelector } from 'react-redux';
import FeatureService from '@/services/feature-service';
import { selectFeatures, selectFeaturesLoaded } from '@/store/slices/features/featuresSlice';

const useFeatures = () => {
  const features = useSelector(selectFeatures);
  const loaded = useSelector(selectFeaturesLoaded);
  
  return {
    /** @param {string} key - FeatureKeys enum value */
    hasFeature: (key) => FeatureService.hasFeature(features, key),
    hasAny: (keys) => FeatureService.hasAnyFeature(features, keys),
    hasAll: (keys) => FeatureService.hasAllFeatures(features, keys),
    features,  // raw Set
    loaded,    // boolean
  };
};

export default useFeatures;
